import { capitalCase } from 'change-case'
export default {
    data: () => ({
        permissionTypes: ['View'],
        activitySection: null,
    }),
    computed: {
        user_permissions() {
            return this.$store.getters.user_permissions
        },
        activitySections() {
            const activityTypes = this.$store.state.orderType.items
            const _sections = activityTypes
                .filter(x => x.name)
                .map(x => {
                    return {
                        id: x.id, // Assuming each activity type has an 'id' property
                        name: capitalCase(x.name),
                    }
                })

            return _sections
        },
    },

    watch: {
    },
    created() {
        this.$store.dispatch('orderType/fetchAll')
    },
    mounted() {
    },

    methods: {
    },
}
